// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Accordion_accordion__rHpoY {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.Accordion_navigation__O\\+DLI {
  display: flex;
  justify-content: center;
  gap: 10px;
  position: relative;
  gap: 32px;
  z-index: 100; /* Навигация должна быть над всеми секциями */
  flex-wrap: wrap;
}
.Accordion_cardTitle__XbEbI{
    min-height: 45px;
    width: 100%;
    font-size: var(--font-size-xl);
    font-weight: var(--font-medium);
    color: var(--color-background);
}
.Accordion_navButton__\\+S3eL {
  padding: 10px 30px;
  background-color: #f0f0f0;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 270px;
}

.Accordion_navButton__\\+S3eL.Accordion_active__Zpp04 {
  /* background-color: #ff6b6b; */
  transform: scale(1.05);
  color: white;
}

.Accordion_sectionsContainer__qUQV9 {
  position: relative; /* Контейнер секций должен иметь position: relative */
  width: 100%;
}

.Accordion_section__trNPE {
  border: 1px solid #e0e0e0;
  margin-bottom: 10px;
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0,0,0,0.1); /* Тень для лучшего эффекта нахлеста */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* При активной секции увеличиваем z-index и тень */
.Accordion_section__trNPE.Accordion_expanded__GFrcF {
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  z-index: 50 !important; /* Активная секция всегда сверху */
}

.Accordion_sectionHeader__6bpbs {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background-color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: relative;
  /* max-width: 1110px; */
  width: 100%;
}

.Accordion_sectionHeader__6bpbs:hover {
  background-color: #f0f0f0;
  width: 100%;
}

.Accordion_contentWrapper__eGY23 {
  width: 100%;
    max-width: 1110px;
  height: auto;
  overflow: hidden;
  transition: height 0.4s ease-in-out;
}

.Accordion_sectionContent__l06PJ {
  padding: 15px;
  background-color: white;
}

.Accordion_sectionHeader__6bpbs h3{
  font-size: var(--font-size-4xl);
  font-weight: var(--font-bold);
  color: var(--color-background);
  margin: 0;
}

/* Стили для содержимого секции */
.Accordion_description__ScNaf {
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  color: var(--color-background);
  font-weight: var(--font-medium);
  font-size: var(--font-size-lg);
}

.Accordion_imagesGrid__GQPPa {
  display: flex;
  /* grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); */
  gap: 28px;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 60px;
}

.Accordion_imageContainer__yv32z {
  overflow: hidden;
  width: 256px;
  transition: transform 0.3s ease;
}

/* .sectionImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
} */
.Accordion_imageContainer__yv32z img{
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border-radius: var(--border-radius-lg);
  width: 100%;
  height: auto;
  object-fit: cover;
}
.Accordion_imageContainer__yv32z p{
  font-size: var(--font-size-lg);
  font-weight: var(--font-medium);
  color: var(--color-background);
  text-align: center;
}
.Accordion_imageContainer__yv32z:hover{
  transform: scale(1.05);
}
/* .sectionCards{
  
} */
.Accordion_linkContainer__Lo14H {
  margin-top: 20px;
  text-align: right;
  display: flex;
  justify-content: center;
}

.Accordion_sectionLink__qxVFw {
  display: inline-block;
  padding: 10px 20px;
  background-color: var(--color-background);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.Accordion_sectionLink__qxVFw:hover {
  background-color: var(--color-accent);
  color: #fff;
  transform: translateY(-2px);
}
@media (max-width: 768px) {
  .Accordion_sectionHeader__6bpbs h3{
    font-size: var(--font-size-2xl);
  }
  .Accordion_contentWrapper__eGY23 p{
    font-size: var(--font-size-md);
  }
  .Accordion_linkContainer__Lo14H{
    margin: 0;
    margin-bottom: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Other/Accordion/Accordion.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,YAAY,EAAE,6CAA6C;EAC3D,eAAe;AACjB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;IAC/B,8BAA8B;AAClC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB,EAAE,qDAAqD;EACzE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,oCAAoC,EAAE,sCAAsC;EAC5E,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,qCAAqC;EACrC,sBAAsB,EAAE,kCAAkC;AAC5D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;IACT,iBAAiB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;EAC9B,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;;;;;;GAMG;AACH;EACE,qCAAqC;EACrC,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;;GAEG;AACH;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,SAAS;IACT,mBAAmB;EACrB;AACF","sourcesContent":[".accordion {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 32px;\n}\n\n.navigation {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  position: relative;\n  gap: 32px;\n  z-index: 100; /* Навигация должна быть над всеми секциями */\n  flex-wrap: wrap;\n}\n.cardTitle{\n    min-height: 45px;\n    width: 100%;\n    font-size: var(--font-size-xl);\n    font-weight: var(--font-medium);\n    color: var(--color-background);\n}\n.navButton {\n  padding: 10px 30px;\n  background-color: #f0f0f0;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 270px;\n}\n\n.navButton.active {\n  /* background-color: #ff6b6b; */\n  transform: scale(1.05);\n  color: white;\n}\n\n.sectionsContainer {\n  position: relative; /* Контейнер секций должен иметь position: relative */\n  width: 100%;\n}\n\n.section {\n  border: 1px solid #e0e0e0;\n  margin-bottom: 10px;\n  border-radius: var(--border-radius-lg);\n  overflow: hidden;\n  box-shadow: 0 0 20px rgba(0,0,0,0.1); /* Тень для лучшего эффекта нахлеста */\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* При активной секции увеличиваем z-index и тень */\n.section.expanded {\n  box-shadow: 0 4px 8px rgba(0,0,0,0.2);\n  z-index: 50 !important; /* Активная секция всегда сверху */\n}\n\n.sectionHeader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n  background-color: #fff;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  position: relative;\n  /* max-width: 1110px; */\n  width: 100%;\n}\n\n.sectionHeader:hover {\n  background-color: #f0f0f0;\n  width: 100%;\n}\n\n.contentWrapper {\n  width: 100%;\n    max-width: 1110px;\n  height: auto;\n  overflow: hidden;\n  transition: height 0.4s ease-in-out;\n}\n\n.sectionContent {\n  padding: 15px;\n  background-color: white;\n}\n\n.sectionHeader h3{\n  font-size: var(--font-size-4xl);\n  font-weight: var(--font-bold);\n  color: var(--color-background);\n  margin: 0;\n}\n\n/* Стили для содержимого секции */\n.description {\n  margin-bottom: 16px;\n  font-size: 16px;\n  line-height: 1.5;\n  text-align: center;\n  color: var(--color-background);\n  font-weight: var(--font-medium);\n  font-size: var(--font-size-lg);\n}\n\n.imagesGrid {\n  display: flex;\n  /* grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); */\n  gap: 28px;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  margin-top: 60px;\n}\n\n.imageContainer {\n  overflow: hidden;\n  width: 256px;\n  transition: transform 0.3s ease;\n}\n\n/* .sectionImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.3s ease;\n} */\n.imageContainer img{\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  border-radius: var(--border-radius-lg);\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n.imageContainer p{\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-medium);\n  color: var(--color-background);\n  text-align: center;\n}\n.imageContainer:hover{\n  transform: scale(1.05);\n}\n/* .sectionCards{\n  \n} */\n.linkContainer {\n  margin-top: 20px;\n  text-align: right;\n  display: flex;\n  justify-content: center;\n}\n\n.sectionLink {\n  display: inline-block;\n  padding: 10px 20px;\n  background-color: var(--color-background);\n  color: white;\n  text-decoration: none;\n  border-radius: 4px;\n  font-weight: 500;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.sectionLink:hover {\n  background-color: var(--color-accent);\n  color: #fff;\n  transform: translateY(-2px);\n}\n@media (max-width: 768px) {\n  .sectionHeader h3{\n    font-size: var(--font-size-2xl);\n  }\n  .contentWrapper p{\n    font-size: var(--font-size-md);\n  }\n  .linkContainer{\n    margin: 0;\n    margin-bottom: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordion": `Accordion_accordion__rHpoY`,
	"navigation": `Accordion_navigation__O+DLI`,
	"cardTitle": `Accordion_cardTitle__XbEbI`,
	"navButton": `Accordion_navButton__+S3eL`,
	"active": `Accordion_active__Zpp04`,
	"sectionsContainer": `Accordion_sectionsContainer__qUQV9`,
	"section": `Accordion_section__trNPE`,
	"expanded": `Accordion_expanded__GFrcF`,
	"sectionHeader": `Accordion_sectionHeader__6bpbs`,
	"contentWrapper": `Accordion_contentWrapper__eGY23`,
	"sectionContent": `Accordion_sectionContent__l06PJ`,
	"description": `Accordion_description__ScNaf`,
	"imagesGrid": `Accordion_imagesGrid__GQPPa`,
	"imageContainer": `Accordion_imageContainer__yv32z`,
	"linkContainer": `Accordion_linkContainer__Lo14H`,
	"sectionLink": `Accordion_sectionLink__qxVFw`
};
export default ___CSS_LOADER_EXPORT___;
